<div class="d-flex flex-column">
  <label for="filter-select">{{filterName}}</label>
  <select id="filter-select" (change)="applyFilter($event.target.value)">
    <option value="">{{'mpupFilter.none' | mbTranslate}}</option>
    <option
      *ngFor="let filterOption of filterOptions"
      [value]="filterOption.value"
    >
      {{filterOption.title}}
    </option>
  </select>
</div>

